module.exports = __webpack_public_path__ + "static/img/member_back.64faf87.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/member_back.jpeg?20181011
// module id = PmOq
// module chunks = 1